module.exports = __webpack_public_path__ + "static/media/k.5a624914.gif";